import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import { useIsDesktop } from "@/lib/useMediaQuery";
import { cn } from "@/lib/utils";

/**
 * Dialog på desktop, Drawer (botn-ark) på mobil. Solide flater, ingen blur.
 */
export const ResponsiveDialog = ({ open, onOpenChange, title, description, children, footer, testId, className, wide = false }) => {
  const isDesktop = useIsDesktop();
  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent
          data-testid={testId}
          className={cn("max-h-[90vh] overflow-y-auto rounded-xl bg-card", wide ? "max-w-3xl" : "max-w-lg", className)}
        >
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            {description ? <DialogDescription>{description}</DialogDescription> : <DialogDescription className="sr-only">{title}</DialogDescription>}
          </DialogHeader>
          <div className="space-y-4">{children}</div>
          {footer ? <DialogFooter className="gap-2 pt-2">{footer}</DialogFooter> : null}
        </DialogContent>
      </Dialog>
    );
  }
  return (
    <Drawer open={open} onOpenChange={onOpenChange} shouldScaleBackground={false}>
      <DrawerContent data-testid={testId} className={cn("max-h-[94vh] rounded-t-xl bg-card", className)}>
        <DrawerHeader className="text-left">
          <DrawerTitle>{title}</DrawerTitle>
          {description ? <DrawerDescription>{description}</DrawerDescription> : <DrawerDescription className="sr-only">{title}</DrawerDescription>}
        </DrawerHeader>
        <div className="overflow-y-auto px-4 pb-2">
          <div className="space-y-4">{children}</div>
        </div>
        {footer ? <DrawerFooter className="safe-bottom border-t border-border bg-card">{footer}</DrawerFooter> : null}
      </DrawerContent>
    </Drawer>
  );
};
